import { Component, computed, input } from '@angular/core';
import { BidLinkPipe } from '@web/shared/pipes/bid-link.pipe';
import { isEmpty } from 'class-validator';
import { BidTagComponent } from '../../bid-tag.component';
import { SearchBidEntry } from '../interfaces/search-bid-entry.interface';
import { DetailItem, SearchItemBaseComponent } from './search-item-base.component';
import { SearchStatusChipComponent } from './search-status-chip.component';

@Component({
  selector: 'app-search-bid-item',
  imports: [BidTagComponent, BidLinkPipe, SearchItemBaseComponent, SearchStatusChipComponent],
  template: `
    @let _item = item();

    <app-search-item-base
      icon="pi pi-briefcase"
      color="text-soe-petrol-blue"
      [detailRouterLink]="_item | bidLink"
      [detailItems]="detailItems()"
    >
      <ng-template #title>
        <div [innerHTML]="_item.name"></div>
      </ng-template>

      <ng-template #codeTag>
        <app-bid-tag [bid]="_item" [clickable]="false" />
      </ng-template>

      <ng-template #statusChip>
        @if (_item.statusName) {
          <app-search-status-chip
            [name]="_item.statusName"
            [backgroundColor]="_item.statusColor"
            [textColor]="_item.statusTextColor"
          />
        }
      </ng-template>
    </app-search-item-base>
  `,
})
export class SearchBidItemComponent {
  readonly item = input.required<SearchBidEntry>();

  readonly detailItems = computed<DetailItem[]>(() => {
    const item = this.item();

    return [
      {
        icon: 'pi pi-tag',
        content: item.interestName,
        isHtml: true,
      },
      {
        icon: 'pi pi-user',
        content: item.targetName,
        isHtml: true,
      },
    ].filter((v) => !isEmpty(v.content));
  });
}
